export default __webpack_public_path__ + "static/media/CoverImage.dc6e0e9a.png";